// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Vo-z","response":"Wo-z","error":"Xo-z","disabled":"Yo-z","buttons":"Zo-z","feedbackQuestionSection":"_o-z","yesNoWrapper":"ap-z"};